import NotificationDialog from "../notificationDialog";
import { Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";
import JwtService from "@/core/services/JwtService";
import router from "@/router";
import PermissionService from "@/core/services/PermissionService";

const onUserDeleted = (deletedUser) => {
    if (deletedUser) {
        if (JwtService.getUser()?.id === deletedUser.id) {
            store.commit(Mutations.PURGE_AUTH, true);
        }
        else {
            NotificationDialog.Notify("UserDeleted", deletedUser.username);

            if (store.getters.getDataType == "UserListDto") {
                const list = store.getters.getTableData.map((_data) => {
                    if (_data.id !== deletedUser.id) {
                        return _data;
                    }
                });

                store.commit(Mutations.SET_TABLE_DATA, list);
            }
        }
    }
}

const onUserRolesChanged = (updatedUser) => {
    if (updatedUser) {
        let reload = false
        if (JwtService.getUser()?.id === updatedUser.id || router.currentRoute.value.name === "manageUserRoles") {
            reload = true;
        }

        if (reload) {
            NotificationDialog.NotifyWarning("UserRolesChanged", updatedUser.username);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }
}

const onUserClaimsChanged = (updatedUser) => {
    if (updatedUser) {
        let reload = false
        if (JwtService.getUser()?.id === updatedUser.id || router.currentRoute.value.name === "manageUserClaims") {
            PermissionService.saveClaims(updatedUser.claims.map(function (claim) {
                return `${claim.module}.${claim.name}`;
            }));

            reload = true;
        }

        if (reload) {
            NotificationDialog.NotifyWarning("UserClaimsChanged", updatedUser.username);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }
}

export { onUserDeleted, onUserRolesChanged, onUserClaimsChanged }